import { Link } from "react-router-dom";

export default function NTAboutSection() {
  return (
    <section className="bg-white">
      <div className="bg-[#1B1F5E] py-4">
        <div className="max-w-7xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white font-semibold text-base text-center sm:text-left">
            Automação industrial: como aplicar na sua empresa
          </p>
          <a
            href="#"
            className="whitespace-nowrap bg-[#3FA7D6] hover:bg-[#2F4F8F] text-white font-bold px-6 py-2.5 rounded-md transition-colors cursor-pointer text-sm"
          >
            Baixar E-book
          </a>
        </div>
      </div>

      <div className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">

            {/* Image */}
            <div className="relative">
              <div className="w-full h-[420px] rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=industrial%20engineering%20team%20working%20factory%20floor%20machinery%20inspection%20professional%20workers%20bright%20clean%20manufacturing%20plant%20modern%20facility&width=700&height=480&seq=ntabout1&orientation=landscape"
                  alt="New Tech Solution equipe"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-5 -right-5 bg-[#1B1F5E] p-6 rounded-lg">
                <p className="font-rajdhani font-bold text-white text-4xl leading-none">10+</p>
                <p className="text-white/80 text-xs mt-1 leading-tight">
                  Anos de<br />experiência
                </p>
              </div>
            </div>

            {/* Text */}
            <div>
              <p className="text-[#3FA7D6] font-bold text-sm uppercase tracking-widest mb-2">
                Nossa História
              </p>

              <h2 className="font-rajdhani font-bold text-[#1a1a1a] text-4xl md:text-5xl leading-tight mb-5">
                De uma picolezeira a<br />
                <span className="text-[#1B1F5E]">referência industrial</span>
              </h2>

              <p className="text-[#555] text-sm leading-relaxed mb-4">
                Nossa história começou com um propósito simples, mas poderoso: criar, inovar e desenvolver soluções industriais que realmente fazem a diferença. O primeiro passo foi a fabricação de uma picolezeira, desenvolvida sob medida para atender uma necessidade específica do setor alimentício.
              </p>

              <p className="text-[#555] text-sm leading-relaxed mb-4">
                Esse projeto marcou o início de uma trajetória de crescimento, inovação e dedicação. Ao longo dos anos, ampliamos nossa atuação, desenvolvendo máquinas e equipamentos para diversos segmentos industriais como metalúrgico, têxtil, alimentício, automobilístico e indústrias de higiene pessoal.
              </p>

              <p className="text-[#555] text-sm leading-relaxed mb-7">
                Com a evolução do mercado e o fortalecimento da nossa expertise, a partir do segundo semestre de 2024 passamos a atuar com foco total no desenvolvimento e fabricação de máquinas e equipamentos especiais. Hoje, transformamos desafios em soluções personalizadas, eficientes e de alto desempenho.
              </p>

              <div className="grid grid-cols-2 gap-3 mb-8">
                {["Qualidade", "Confiabilidade", "Parceria", "Inovação"].map((v) => (
                  <div key={v} className="flex items-center gap-2">
                    <div className="w-4 h-4 flex items-center justify-center text-[#3FA7D6]">
                      <i className="ri-checkbox-circle-fill text-sm"></i>
                    </div>
                    <span className="text-[#333] text-sm font-medium">{v}</span>
                  </div>
                ))}
              </div>

              <Link
                to="/sobre"
                className="inline-flex items-center gap-2 bg-[#1B1F5E] hover:bg-[#2F4F8F] text-white font-bold px-7 py-3.5 rounded-md transition-colors cursor-pointer whitespace-nowrap text-sm"
              >
                Conheça Nossa História
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}